import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Container from 'gatsby-theme-core/src/components/container';

import Section from '../../components/section';

import Wrapper from './wrapper';
import Title from './title';
import Text from './text';
import Item from './item';
import ImageWrapper from './image-wrapper';

const IconicText = ({ rowOptions, items, className }) => {
  if (items?.length <= 0) {
    return null;
  }
  return (
    <Section
      id={rowOptions?.sectionId || ''}
      backgroundColor={rowOptions?.backgroundColor}
      hideBottomSpacing={rowOptions?.hideBottomSpacing}
      hideTopSpacing={rowOptions?.hideTopSpacing}
      hideRow={rowOptions?.hideRow}
      className={className}
    >
      <Container small>
        <Wrapper numberOfItems={items?.length}>
          {items.map((item) => item && (
            <Item key={item.id}>
              <ImageWrapper>
                <Image
                  image={item.image}
                  alt={item.title}
                  objectFit="contain"
                />
              </ImageWrapper>
              <div>
                {item.title && (
                  <Title>{item.title}</Title>
                )}
                {item.text && (
                  <Text>{item.text}</Text>
                )}
              </div>
            </Item>
          ))}
        </Wrapper>
      </Container>
    </Section>
  );
};

export default styled(IconicText)``;
